export default {
  TITLE: "Weekly Reports Aggregate Report",
  TOTAL_SALES: "Total Sales",
  TOTAL_PURCHASES: "Total Purchases",
  NET_PROFIT: "Net Profit",
  TOTAL_WAGES: "Total Wages",
  TOTAL_RENT: "Total Rent",
  WEEKLY_AVERAGE_SALES: "Avg. Sales / Week",
  AVG_WAGES_RATIO: "Avg. Wages Ratio",
  AVG_RENT_RATIO: "Avg. Rent Ratio",
  AVG_PURCHASES_RATIO: "Avg. Purchases Ratio",
  AVG_NET_PROFIT_RATIO: "Avg. Net Profit Ratio",
  AVG_PER_WEEK: "Avg. / week",
  AVG_RATIO: "Avg. ratio",
  SALES: "Sales",
  PURCHASES: "Purchases",
  PURCHASES_CONSUMABLES: "Consumables Purchases",
  PROFITS: "Profits",
  NUMBER_OF_REPORTS: "Number of Reports",
  EVOLUTION_OVER_TIME: "Sales / Purchases / Profit over time",
  RATIOS_EVOLUTION_OVER_TIME: "Ratios evolution over time",
  PERIOD: "Period",
  WAGES: "Wages",
  RENT: "Rent",
  WAGES_RATIO: "Wages Ratio",
  RENT_RATIO: "Rent Ratio",
  PURCHASES_RATIO: "Purchases Ratio",
  NET_PROFIT_RATIO: "Profit Ratio",
};
